module.exports = __webpack_public_path__ + "static/media/amb.59c23689.svg";